import React from 'react'

export default function AboutExcellence() {
    return (
        <section className="about-excellence">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <div className="excellence-left">
                            <div className="excellence-items">
                                <div className="icon-wrapper">
                                    <div className="icon">
                                        <img src="/assets/images/excellence-icon1.webp" alt="Excellence" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="content-wrapper">
                                    <div className="heading heading-wrapper">
                                        35+ Years Of Industry Expertise
                                    </div>
                                    <p>Since 1990, Supershine has combined operational experience, proven technology, and deep industry knowledge to deliver reliable commercial laundry solutions.
                                    </p>
                                </div>
                            </div>


                            <div className="excellence-items">
                                <div className="icon-wrapper">
                                    <div className="icon">
                                        <img src="/assets/images/excellence-icon2.webp" alt="Excellence" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="content-wrapper">
                                    <div className="heading heading-wrapper">
                                        Efficient Processes, Superior Results
                                    </div>
                                    <p>Supershine brings decades of process discipline and consistent quality to every commercial laundry project we implement.
                                    </p>
                                </div>
                            </div>


                            <div className="excellence-items">
                                <div className="icon-wrapper">
                                    <div className="icon">
                                        <img src="/assets/images/excellence-icon3.webp" alt="Excellence" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="content-wrapper">
                                    <div className="heading heading-wrapper">
                                        Expert Laundry & Engineering Team
                                    </div>
                                    <p>Our specialists deliver systematic, predictable, and high-performance commercial laundry solutions across diverse industries.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <div className="excellence-image">
                            <h4 className="heading">Smart, Sustainable, & Scalable Laundry Excellence</h4>
                            <p>Our approach combines advanced automation, environmentally conscious operations, and modular systems to deliver consistent, streamlined, and future-proof laundry solutions for growing commercial businesses.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
